import React from 'react';
import { IconButton, InputBase, Paper } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { useState } from 'react';

type TPesquisaProps = {
  handleLike: (textValue: string) => void;
};

const BtnPesquisa = (props: TPesquisaProps) => {
  const [textValue, setTextValue] = useState<string>('');

  const pesquisar = () => {
    if (textValue.trim().length > 0) {
      props.handleLike(textValue);
    }
  };

  const valuePesquisa = (e: any) => {
    const text = e.target.value;
    if (text.trim().length === 0) {
      props.handleLike('all');
      return;
    }
    setTextValue(text);
  };

  const keyEnter = (e: any) => {
    if (e.keyCode === 13) {
      pesquisar();
    }
  };

  return (
    <Paper
      sx={{
        p: '2px 4px',
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        maxWidth: 500,
      }}
    >
      <InputBase
        sx={{ ml: 1, flex: 1 }}
        placeholder="Pesquisar"
        onChange={valuePesquisa}
        onKeyDown={keyEnter}
        inputProps={{ 'aria-label': 'Pesquisar' }}
      />
      <IconButton type="button" sx={{ p: '10px' }} aria-label="search" onClick={pesquisar}>
        <SearchIcon />
      </IconButton>
    </Paper>
  );
};

export default BtnPesquisa;
